import { watch, type Directive } from 'vue';
import { checkAuth, modeType } from '@/utils/auth';
import { useAccountStore } from '@/stores/user';
// 定义自定义指令
const authDirective: Directive = {
  mounted(el, binding) {
    const account = useAccountStore();
    watch([() => account.updateAccessStatus, () => account.isLogin], ([accessVal, isLoginVal]) => {
      if (accessVal || !isLoginVal) {
        const { value } = binding;
        const config = {
          skip: value?.skip || false,
          mode: value?.mode || modeType.OR
        };
        const hasPermission = checkAuth(value.authority, config);
        const hasOtherPermission = value.other || false;
        if (!hasPermission && !hasOtherPermission) {
          el.parentNode && el.parentNode.removeChild(el); // 如果没有权限，从DOM中移除元素
        }
      }
    }, { immediate: true });
  }
};

export default authDirective;
